import React from 'react';

import { Feature, PageTitle } from '../../../components';
import { features } from '../../../constants';



const FeaturePage = () => {

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Features'} page={'Features'} />

      <section className='features'>
  
      {/* Container for feature items */}
      <div className="box-container">

        {/* Map through the features array and render each feature */}
        {features.map((feature) => (
          <Feature key={feature.id} feature={feature} />
        ))}

      </div>

    </section>
    </> 
  );
}

export default FeaturePage;